<template>
  <b-modal
    ref="departmentsConfigurationModal"
    size="md"
    centered
    modal-class="departments-configuration-modal"
    @hidden="hide"
  >
    <div slot="modal-title">
      {{ actionTitle }} <span style="text-transform: lowercase">{{ $tc('configuration.sections.department', 1) }}</span>
    </div>
    <b-row>
      <b-col>
        <div class="form-card">
          <span class="ap-title ap-title__section"><i
            class="far fa-clinic-medical mr-2 mb-2"
            aria-hidden="true"
          />{{ $t('configuration.modal.department.departmentData') }}</span>
          <b-row class="mt-2">
            <b-col
              cols="3"
              class="mb-3"
            >
              <div class="form-label">
                <label>{{ $t('configuration.grid.externalCode') }}</label>
              </div>
              <vt-input
                v-model="internalDepartment.code"
                v-validate="'required'"
                :class="{ requiredForm: (showErrors && !internalDepartment.code) }"
                class="form-control-sm"
              />
            </b-col>
            <b-col
              cols="9"
              class="mb-3"
            >
              <div class="form-label">
                <label>{{ $tc('configuration.sections.department', 1) }}</label>
              </div>
              <vt-input
                v-model="internalDepartment.name"
                v-validate="'required'"
                :class="{ requiredForm: (showErrors && !internalDepartment.name) }"
                class="form-control-sm"
              />
            </b-col>
            <b-col
              cols="6"
              class="mb-3"
            >
              <div class="form-label">
                <label>{{ $tc('configuration.sections.center', 1) }}</label>
              </div>
              <vt-combo-select
                v-model="internalDepartment.center"
                v-validate="'required'"
                :class="{ requiredForm: (showErrors && !internalDepartment.center) }"
                :option-loader="getCentersByName"
                label="name"
                @input="$forceUpdate()"
              />
            </b-col>
            <b-col
              cols="6"
              class="mb-3"
            >
              <div class="form-label">
                <label>{{ $tc('configuration.sections.departmentType', 1) }}</label>
              </div>
              <vt-combo-select
                v-model="internalDepartment.departmentType"
                v-validate="'required'"
                :class="{ requiredForm: (showErrors && !internalDepartment.departmentType) }"
                :option-loader="getDepartmentTypesByName"
                label="name"
                @input="$forceUpdate()"
              />
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col>
        <div class="form-card">
          <span class="ap-title ap-title__section"><i
            class="far fa-envelope mr-2 mb-2"
            aria-hidden="true"
          />{{ $t('configuration.modal.contactAndNotifications') }}</span>
          <b-row class="mt-2">
            <b-col
              cols="6"
              class="mb-3"
            >
              <div class="form-label">
                <label>{{ $t('configuration.grid.email') }}</label>
              </div>
              <vt-input
                v-model="internalDepartment.contactInformation.email"
                v-validate="'required'"
                :class="{ requiredForm: (showErrors && !internalDepartment.contactInformation.email) }"
                class="form-control-sm"
              />
            </b-col>
            <b-col
              cols="6"
              class="mb-3 d-flex align-items-center justify-content-end"
            >
              <div class="switch-btn mt-1 p-0 d-flex align-items-center">
                <span class="mr-2">{{ $t('configuration.modal.emailNotifications') }}</span>
                <input
                  id="toggle-email"
                  v-model="internalDepartment.contactInformation.emailNotificationEnabled"
                  :disabled="!internalDepartment.contactInformation.email"
                  type="checkbox"
                  class="offscreen"
                  aria-hidden="true"
                >
                <label
                  for="toggle-email"
                  class="switch mb-0"
                />
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="6"
              class="mb-3"
            >
              <div class="form-label">
                <label>{{ $t('configuration.grid.phone') }}</label>
              </div>
              <vt-input
                v-model="internalDepartment.contactInformation.mainPhone"
                v-validate="'required'"
                :class="{ requiredForm: (showErrors && !internalDepartment.contactInformation.mainPhone) }"
                class="form-control-sm"
              />
            </b-col>
            <b-col
              cols="6"
              class="mb-3 d-flex align-items-center justify-content-end"
            >
              <div class="switch-btn mt-1 p-0 d-flex align-items-center">
                <span class="mr-2">{{ $t('configuration.modal.smsNotifications') }}</span>
                <input
                  id="toggle-sms"
                  v-model="internalDepartment.contactInformation.smsNotificationEnabled"
                  :disabled="!internalDepartment.contactInformation.mainPhone"
                  type="checkbox"
                  class="offscreen"
                  aria-hidden="true"
                >
                <label
                  for="toggle-sms"
                  class="switch mb-0"
                />
              </div>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        cols="12"
        class="my-2 d-flex justify-content-end"
      >
        <div class="switch-btn mt-1 p-0 d-flex align-items-center">
          <span class="mr-2">{{ $t('configuration.actions.active') }}</span>
          <input
            id="toggle"
            v-model="internalDepartment.active"
            type="checkbox"
            class="offscreen"
            aria-hidden="true"
          >
          <label
            for="toggle"
            class="switch mb-0"
          />
        </div>
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-6 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-6 text-right">
          <b-button
            size="sm"
            class="btn--primary"
            @click="update()"
          >
            <i
              class="fal fa-check mr-2"
              aria-hidden="true"
            />
            {{ actionTitle }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>

import { cloneDeep, isEmpty } from 'lodash'
import ConfigurationDepartmentTypeServices
    from '@/api/resources/configuration/centersAndAreas/departmentType/ConfigurationDepartmentTypeServices'
import ConfigurationCenterServices
    from '@/api/resources/configuration/centersAndAreas/center/ConfigurationCenterServices'
import { GridUtils } from '@/shared/util/grid-utils'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'

export default {
    name: 'DepartmentsConfigurationModal',
    props: {
        actionTitle: String
    },
    data() {
        return {
            showErrors: false,
            internalDepartment: {
                active: true,
                contactInformation: {}
            }
        }
    },
    methods: {
        show(selectedDepartment) {
            if (selectedDepartment && !isEmpty(selectedDepartment)) {
                this.internalDepartment = cloneDeep(selectedDepartment)
            }
            this.$refs.departmentsConfigurationModal.show()
        },
        async update() {
            const validForm = await this.$validator.validate()
            if (!validForm) {
                this.showErrors = true
                this.showErrorModalGlobal(this.$t('studyRequest.general.requiredFieldsNotice'))
            } else {
                if (this.internalDepartment.id) this.$emit('update', this.internalDepartment)
                else this.$emit('create', this.internalDepartment)
            }
        },
        hide() {
            this.$refs.departmentsConfigurationModal.hide()
            this.clearData()
        },
        async getCentersByName() {
            const filterModel = {
                'name': GridUtils.getTextFilterModel('contains', '')
            }
            const params = {
                size: PAGINATOR_BIG_PAGE_SIZE
            }
            const response = await this.$_toCallSecure(ConfigurationCenterServices.paginator(filterModel, params))
            return response?.content ?? []
        },
        async getDepartmentTypesByName() {
            const filterModel = {
                'name': GridUtils.getTextFilterModel('contains', '')
            }
            const params = {
                size: PAGINATOR_BIG_PAGE_SIZE
            }
            const response = await this.$_toCallSecure(ConfigurationDepartmentTypeServices.paginator(filterModel, params))
            return response?.content ?? []
        },
        clearData() {
            this.$_cleanComponentData()
        }
    }
}
</script>

<style lang="scss">
    .requiredForm {
        border-color: red;
    }
    .requiredForm .multiselect__tags {
        border-color: red;
    }
</style>
